import React, { useEffect, useState } from 'react'
import { Div } from './Components'
import InputDate from '../../../../components/modalComponents/InputDate'
import InputSelect from '../../../../components/modalComponents/InputSelect'
import InputTextArea from '../../../../components/modalComponents/InputTextArea'
import InputUploadFile from '../../../../components/modalComponents/InputUploadFile'
import InputText from '../../../../components/modalComponents/InputText'
import { useManagePostRequest } from '../../../../hooks/useManagePostRequest/useManagePostRequest'
import { calculateDaysInBetween, isNullOrUndefinded, parseStringToDate } from '../../../../helper/utils'
import { getListaDocumentosCondicionAPI, ToggleRegistradoEnOfisisAPI } from '../../../../consumers/backendApisUrls'
import CustomAlert from '../../../../components/alerts/CustomAlert'
import { INSTITUCIONES_MEDICAS } from '../../../../constants/hardCodedConstants'
import InputBool from '../../../../components/modalComponents/InputBool'

import {estados} from "../../../../constants/states";

const DescansoMedico = ({
  selectProps,
  commonProps,
  formValues,
  setFormValues,
  KEYS,
  sectionName,
  setIsUploading,
  isDisabled = false,
  dmsAprobadosAcumuladosEsteAnio = 0,
  dmsAprobadosAcumuladosEsteAnioYAnioAnterior =0,
  isAdmin = false,
  puedeVerCamposAdmin = false,
  idEmpleado,
  isCreate = false,
  excede140Consecutivo = false,
  excede80NoConsecutivo = false,
  estariaExcediendo140Consecutivo = false,
  estariaExcediendo80NoConsecutivo = false,
  checkDeclaracionJurada = false,
  setCheckDeclaracionJurada = () => {}
}) => {
  const [executePost] = useManagePostRequest();
  const [listDocuments, setListDocuments] = useState(formValues[KEYS.documentos] || []);

  useEffect(() => {
    if (formValues[KEYS.documentos]) {
      setListDocuments(formValues[KEYS.documentos]);
    }
    if (formValues[KEYS.idCIE10] === 9999) {
      setOtroCIE10(true);
    }
    if (formValues[KEYS.idTipologia] === 9999) {
      setOtroTipologia(true);
    }
  }, [formValues]);

  const onChangeInstitucionDescansoMedico = async (res) => {
    selectProps(KEYS.idInstitucionDescansoMedico).onChange(res);
    try {
      const payload = {
        [KEYS.idEmpleado]: idEmpleado,
        [KEYS.idTipoDeCondicion]: formValues[KEYS.idTipoDeCondicion],
        [KEYS.idInstitucionDescansoMedico]: res?.target?.value?.value,
        [KEYS.fechaInicioCondicion]: formValues[KEYS.fechaInicioCondicion],
        [KEYS.fechaFinCondicion]: formValues[KEYS.fechaFinCondicion],
        [KEYS.agregarCartaCompromiso]: formValues[KEYS.tieneSubsidio],
      };
      await getDocuments(payload);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeSubsidio = async (res) => {
    commonProps(KEYS.tieneSubsidio).onChange(res);
    try {
      const payload = {
        [KEYS.idEmpleado]: idEmpleado,
        [KEYS.idTipoDeCondicion]: formValues[KEYS.idTipoDeCondicion],
        [KEYS.idInstitucionDescansoMedico]: formValues[KEYS.idInstitucionDescansoMedico],
        [KEYS.fechaInicioCondicion]: formValues[KEYS.fechaInicioCondicion],
        [KEYS.fechaFinCondicion]: formValues[KEYS.fechaFinCondicion],
        [KEYS.agregarCartaCompromiso]: res.target.checked,
      };
      await getDocuments(payload);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeRegistradoEnOfisis = (res) => {
    commonProps(KEYS.registradoEnOfisis).onChange(res);
  };

  async function getDocuments(payload) {
    const api = getListaDocumentosCondicionAPI();
    const response = await executePost(api, payload, successSubmitCallback);
    let prevDocs = formValues[KEYS.documentos] || [];
    if (response.data) {
      let newDocs = response.data[KEYS.documentos];
      let newState = newDocs.map((doc) => {
        const prevDoc = prevDocs.find((prevDoc) => prevDoc.Discriminator === doc.Discriminator);
        return prevDoc ? prevDoc : doc;
      });
      setListDocuments(newState);
    }
  }

  const onUploadFile = (res, i) => {
    setIsUploading(true);

    const newState = [...listDocuments];
    newState[i].File = res;

    setListDocuments(newState);
    setFormValues((prevState) => {
      const newForm = { ...prevState };
      newForm[KEYS.documentos] = newState;
      return newForm;
    });

    setIsUploading(false);
  };

  const successSubmitCallback = async () => {};

  const institucionDescansoMedico = (
    <Div>
      {isDisabled ? (
        <InputText
          label="Institución emisora"
          name={KEYS.institucionDescansoMedico}
          value={formValues[KEYS.institucionDescansoMedico]}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <InputSelect
          label="Institución emisora"
          {...selectProps(KEYS.idInstitucionDescansoMedico)}
          onChange={onChangeInstitucionDescansoMedico}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      )}
    </Div>
  );

  const tieneSubsidio = !isCreate && (
    <Div>
      <InputBool
        label="Subsidio"
        name={KEYS.tieneSubsidio}
        value={formValues[KEYS.tieneSubsidio]}
        {...commonProps(KEYS.tieneSubsidio)}
        onChange={onChangeSubsidio}
        sectionName={sectionName}
        isDisabled={!isAdmin || isDisabled}
      />
    </Div>
  );

  const registradoEnOfisis = puedeVerCamposAdmin && !isCreate && (
    <div className="col-md-6">
      <InputBool
        label="Registrado en Ofisis"
        name={KEYS.registradoEnOfisis}
        value={formValues[KEYS.registradoEnOfisis]}
        {...commonProps(KEYS.registradoEnOfisis)}
        onChange={onChangeRegistradoEnOfisis}
        sectionName={sectionName}
        isDisabled={isDisabled}
      />
    </div>
  );

  const derivadoPsicoEmocional = isAdmin && !isCreate && (
    <div className="col-md-6">
      <InputBool
        label="Derivado a Psic.Socio.Emoc."
        name={KEYS.derivadoPsicoEmocional}
        value={formValues[KEYS.derivadoPsicoEmocional]}
        {...commonProps(KEYS.derivadoPsicoEmocional)}
        sectionName={sectionName}
        isDisabled={isDisabled}
      />
    </div>
  );

  const descuentoEnPlanilla = isAdmin && !isCreate && (
    <div className="col-md-6">
      <InputBool
        label="Dscto. en planilla"
        name={KEYS.descuentoEnPlanilla}
        value={formValues[KEYS.descuentoEnPlanilla]}
        {...commonProps(KEYS.descuentoEnPlanilla)}
        sectionName={sectionName}
        isDisabled={isDisabled}
      />
    </div>
  );

  const auditarDescansoMedico = isAdmin && !isCreate && (
    <div className="col-md-6">
      <InputBool
        label="Auditar descanso med."
        name={KEYS.auditarDescansoMedico}
        value={formValues[KEYS.auditarDescansoMedico]}
        {...commonProps(KEYS.auditarDescansoMedico)}
        sectionName={sectionName}
        isDisabled={isDisabled}
      />
    </div>
  );
  const division = (
    <div className="col-md-12">
      <hr />
    </div>
  );
  const documentoCanjeDMEssaludCittFirmado = formValues[KEYS.documentoCanjeDMEssaludCittFirmado] && (
    <Div>
      <InputUploadFile
        label="Documento Canje DM Essalud CITT"
        name={KEYS.documentoCanjeDMEssaludCittFirmado}
        uploadFile={formValues[KEYS.documentoCanjeDMEssaludCittFirmado]}
        sectionName={sectionName}
        isDisabled
      />
    </Div>
  );

  const motivoDescansoMedico = (
    <Div>
      {isDisabled ? (
        <InputText
          label="Motivo de descanso"
          name={KEYS.motivoDescansoMedico}
          value={formValues[KEYS.motivoDescansoMedico]}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <InputSelect
          label="Motivo de descanso"
          {...selectProps(KEYS.idMotivoDescansoMedico, [
            KEYS.certificadoFileViewModel,
            KEYS.pagoConsultaFileViewModel,
            KEYS.recetaMedicaFileViewModel,
            KEYS.pagoRecetaMedicaFileViewModel,
            KEYS.descansoMedicoCITTFileViewModel,
            KEYS.descansoMedicoFileViewModel,
            KEYS.anexo18FileViewModel,
            KEYS.ultimoInformeEcograficoFileViewModel,
          ])}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      )}
    </Div>
  );

  function getDays() {
    if (formValues[KEYS.fechaInicioCondicion] && formValues[KEYS.fechaFinCondicion])
      return calculateDaysInBetween(formValues[KEYS.fechaInicioCondicion], formValues[KEYS.fechaFinCondicion]);

    return "-";
  }

  function getDaysCurrentYear() {
    if (formValues[KEYS.fechaInicioCondicion] && formValues[KEYS.fechaFinCondicion])
    {
      let start_Date = parseStringToDate(formValues[KEYS.fechaInicioCondicion]);
      let end_Date = parseStringToDate(formValues[KEYS.fechaFinCondicion]);

      let fechaFinTemp =
                   end_Date.getFullYear() > new Date().getFullYear() ?
                   new Date().getFullYear() +"-12-31":
                   formValues[KEYS.fechaFinCondicion];

      let fechaInicioTemp = start_Date.getFullYear() < new Date().getFullYear() ?
                 new Date().getFullYear() +"-01-01":
                 formValues[KEYS.fechaInicioCondicion];

      let cantidadDias = calculateDaysInBetween(fechaInicioTemp, fechaFinTemp);
      return cantidadDias;
    }
    return 0;
  }



  async function onChangeDates(value, e) {
    commonProps(value).onChange(e);
    try {
      if (formValues[KEYS.idInstitucionDescansoMedico] === INSTITUCIONES_MEDICAS.PARTICULAR) {
        const payload = {
          [KEYS.idEmpleado]: idEmpleado,
          [KEYS.idTipoDeCondicion]: formValues[KEYS.idTipoDeCondicion],
          [KEYS.idInstitucionDescansoMedico]: formValues[KEYS.idInstitucionDescansoMedico],
          [KEYS.fechaInicioCondicion]:
            value === KEYS.fechaInicioCondicion ? e.target.value : formValues[KEYS.fechaInicioCondicion],
          [KEYS.fechaFinCondicion]:
            value === KEYS.fechaFinCondicion ? e.target.value : formValues[KEYS.fechaFinCondicion],
          [KEYS.agregarCartaCompromiso]: formValues[KEYS.tieneSubsidio],
        };
        await getDocuments(payload);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const intervaloDeDescansoMedico = (
    <>
      <Div>
        <InputDate
          label={"Fecha de inicio"}
          name={KEYS.fechaInicioCondicion}
          max={formValues[KEYS.fechaFinCondicion]}
          {...commonProps(KEYS.fechaInicioCondicion, [KEYS.cantidadDias])}
          onChange={(e) => onChangeDates(KEYS.fechaInicioCondicion, e)}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      </Div>
      <Div>
        <InputDate
          label={"Fecha de fin"}
          name={KEYS.fechaFinCondicion}
          min={formValues[KEYS.fechaInicioCondicion]}
          {...commonProps(KEYS.fechaFinCondicion, [KEYS.cantidadDias])}
          onChange={(e) => onChangeDates(KEYS.fechaFinCondicion, e)}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      </Div>
      <Div>
        <InputText
          label={"Cantidad de días"}
          name={"Cantidad de días"}
          value={getDays()}
          sectionName={sectionName}
          isDisabled
        />
      </Div>
      <Div>&nbsp;</Div>



      
      {!isCreate && (
        <>
        <Div>
          <InputText
            label={"Días DM's aprobados acumulados en el año actual"}
            name={"Días DM's aprobados acumulados en el año actual"}
            value={dmsAprobadosAcumuladosEsteAnio}
            sectionName={sectionName}
            isDisabled
          />
        </Div>
        <Div>
          <InputText
            label={"Días DM's aprobados acumulados en el año actual y anterior"}
            name={"Días DM's aprobados acumulados en el año actual y anterior"}
            value={dmsAprobadosAcumuladosEsteAnioYAnioAnterior}
            sectionName={sectionName}
            isDisabled
          />
        </Div>
        </>
      )}
    </>
  );

  const documentTable = (
    <div className="col-md-12">
      <table className="table table-hover table-bordered">
        <thead className="listar-thead">
          <tr>
            <th className="table-header-bold">Nombre de documento</th>
            <th className="table-header-bold">Plantilla</th>
            <th className="table-header-bold">Documento</th>
          </tr>
        </thead>
        <tbody className="listar-tbody">
          {listDocuments?.length === 0 && (
            <tr>
              <td colSpan="3" className="text-center py-2">
                No se han subido documentos
              </td>
            </tr>
          )}
          {listDocuments?.map((document, i) => (
            <tr key={`${i}-${document.value}`}>
              <td>{document?.NombreDocumento}</td>
              <td className="text-center upload-file-p-small">
                <InputUploadFile
                  name={document?.NombreDocumento}
                  uploadFile={document?.PlantillaDocumento}
                  colInput={12}
                  sectionName={sectionName}
                  isDisabled={true}
                  isIcon={true}
                  NoFileMessage="-"
                />
              </td>
              <td className="text-center upload-file-p-small">
                <InputUploadFile
                  name={document?.NombreDocumento}
                  uploadFile={document?.File}
                  setUploadFile={(res) => onUploadFile(res, i)}
                  colInput={12}
                  sectionName={sectionName}
                  isDisabled={isDisabled}
                  isIcon={true}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const alert20diasDM = formValues[KEYS.dMsAprobadosAcumuladosEsteAnioMayor20Dias] && (
    <div className="col-md-12">
      <CustomAlert variant={"warning"} isDismissible={false}>
        Supera los 20 días de descansos médicos aprobados en el año actual.
      </CustomAlert>
    </div>
  );

  function alertaUmbralesComeciAlCrear() {
    // JERARQUÍA DE ALERTAS - Mostrar solo UNA según el estado del empleado
    // Lee desde formValues que contiene los datos mapeados desde GetInfoToCreateCondicion

    // NIVEL 1 (ROJO): Si tiene COMECI activo
    if (formValues["Comeci"] === true) {
      return (
        <div className="col-md-12">
          <CustomAlert variant="danger" isDismissible={false}>
            <strong>🚨 Proceso COMECI Activo</strong> — El colaborador tiene un proceso COMECI activo en el año actual.
          </CustomAlert>
        </div>
      );
    }

    // NIVEL 2 (AMARILLO): Si NO tiene COMECI pero YA tiene los límites alcanzados (estado actual: >= 140 o >= 80)
    if (formValues["Excede140Consecutivo"] === true) {
      return (
        <div className="col-md-12">
          <CustomAlert variant="warning" isDismissible={false}>
            <strong>⚠️ Límite Alcanzado</strong> — Ya tiene 140 días de descansos médicos aprobados consecutivos en el año actual.
          </CustomAlert>
        </div>
      );
    }

    if (formValues["Excede80NoConsecutivo"] === true) {
      return (
        <div className="col-md-12">
          <CustomAlert variant="warning" isDismissible={false}>
            <strong>⚠️ Límite Alcanzado</strong> — Ya tiene 80 días de descansos médicos aprobados no consecutivos en el año actual.
          </CustomAlert>
        </div>
      );
    }

    // NIVEL 3 (AMARILLO): Si NO tiene COMECI, NO está en el límite, pero SI estaría pasando de los límites al aprobar
    if (formValues["EstariaExcediendo140Consecutivo"] === true) {
      return (
        <div className="col-md-12">
          <CustomAlert variant="warning" isDismissible={false}>
            <strong>⚠️ Advertencia</strong> — Si la solicitud es aprobada superará los 140 días consecutivos aprobados iniciando proceso COMECI.
          </CustomAlert>
        </div>
      );
    }

    if (formValues["EstariaExcediendo80NoConsecutivo"] === true) {
      return (
        <div className="col-md-12">
          <CustomAlert variant="warning" isDismissible={false}>
            <strong>⚠️ Advertencia</strong> — Si la solicitud es aprobada superará los 80 días no consecutivos aprobados iniciando proceso COMECI.
          </CustomAlert>
        </div>
      );
    }

    // Si no cumple ninguna condición → No mostrar nada
    return null;
  }

  const alertRegistroPendiente = formValues[KEYS.idEstadoAprobacion] === estados.Pendiente.id && !isAdmin && (
    <div className="col-md-12">
      <CustomAlert variant={"warning"} isDismissible={false}>
      Tu solicitud será evaluada los próximos días por el equipo de Bienestar, una vez aprobada te llegará una notificación.
      </CustomAlert>
    </div>
  );

  function alert20diasDMAlCrear() {
    if (formValues[KEYS.idCondicion]) return;
    if (dmsAprobadosAcumuladosEsteAnio >= 20) {
      return (
        <div className="col-md-12">
          <CustomAlert variant={"warning"} isDismissible={false}>
          Supera los 20 días de descansos médicos aprobados en el año actual.
          </CustomAlert>
        </div>
      );
    }
    if (
      //formValues[KEYS.idInstitucionDescansoMedico] == INSTITUCIONES_MEDICAS.PARTICULAR &&
      dmsAprobadosAcumuladosEsteAnio + getDaysCurrentYear() > 20
    ) {
      return (
        <div className="col-md-12">
          <CustomAlert variant={"warning"} isDismissible={false}>
            Con el descanso médico que se está solicitando superarás los 20 días en el año actual.
          </CustomAlert>
        </div>
      );
    }
  }

  function AlertaTieneDescansoMedicoAprobadoEnDiciembreDelAnioPasado() {
    if (formValues[KEYS.tieneSubsidioContinuado] === true){
      return (
      <div className="col-md-12">
        <CustomAlert variant={"warning"} isDismissible={false}>
         El colaborador presenta subsidio continuado desde diciembre.
        </CustomAlert>
      </div>)
    }else {
      return <></>
    }
  }

  const [otroCIE10, setOtroCIE10] = useState(false);
  const [otroTipologia, setOtroTipologia] = useState(false);

  const onChangeCIE10 = (res) => {
    const selectedValue = res?.target?.value?.value;
    if (selectedValue === 9999) {
      setOtroCIE10(true);
      selectProps(KEYS.idCIE10).onChange(res);
      setFormValues(prev => ({ ...prev, [KEYS.cie10Otro]: "" }));
    } else {
      setOtroCIE10(false);
      selectProps(KEYS.idCIE10).onChange(res);
    }
  };

  const cie10Campo = (
    <Div>
      {isDisabled ? (
        <InputText
          label="CIE-10"
          name={"cie10Display"}
          value={formValues[KEYS.cie10Display] || ""}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <>
          <InputSelect
            label="CIE-10"
            {...selectProps(KEYS.idCIE10)}
            onChange={onChangeCIE10}
            sectionName={sectionName}
            isDisabled={isDisabled}
            isRequired={!isDisabled}
          />
          {otroCIE10 && (
            <InputText
              label="Otro CIE-10"
              name={KEYS.cie10Otro}
              {...commonProps(KEYS.cie10Otro)}
              sectionName={sectionName}
              isDisabled={isDisabled}
              isRequired={!isDisabled}
            />
          )}
        </>
      )}
    </Div>
  );

  const onChangeTipologia = (res) => {
    const selectedValue = res?.target?.value?.value;
    if (selectedValue === 9999) {
      setOtroTipologia(true);
      selectProps(KEYS.idTipologia).onChange(res);
      setFormValues(prev => ({ ...prev, [KEYS.tipologiaOtro]: "" }));
    } else {
      setOtroTipologia(false);
      selectProps(KEYS.idTipologia).onChange(res);
    }
  };

  const tipologiaCampo = (
    <Div>
      {isDisabled ? (
        <InputText
          label="Tipología"
          name={"tipologiaDisplay"}
          value={formValues[KEYS.tipologiaDisplay] || ""}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <>
          <InputSelect
            label="Tipología"
            {...selectProps(KEYS.idTipologia)}
            onChange={onChangeTipologia}
            sectionName={sectionName}
            isDisabled={isDisabled}
            isRequired={!isDisabled}
          />
          {otroTipologia && (
            <InputText
              label="Otra tipología"
              name={KEYS.tipologiaOtro}
              {...commonProps(KEYS.tipologiaOtro)}
              sectionName={sectionName}
              isDisabled={isDisabled}
              isRequired={!isDisabled}
              maxLength={200}
            />
          )}
        </>
      )}
    </Div>
  );

  const cmpCampo = (
    <Div>
      {isDisabled ? (
        <InputText
          label="CMP"
          name={KEYS.cmp}
          value={formValues[KEYS.cmp]}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <InputText
          label="CMP"
          name={KEYS.cmp}
          {...commonProps(KEYS.cmp)}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      )}
    </Div>
  );

  const nombreMedicoCampo = (
    <Div>
      {isDisabled ? (
        <InputText
          label="Nombre del Médico"
          name={KEYS.nombreMedico}
          value={formValues[KEYS.nombreMedico]}
          sectionName={sectionName}
          isDisabled
        />
      ) : (
        <InputText
          label="Nombre del Médico"
          name={KEYS.nombreMedico}
          {...commonProps(KEYS.nombreMedico)}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
        />
      )}
    </Div>
  );
  const nombreInstitucionEmisora = (
      <Div>
        <InputText
          label="Nombre de Institución Emisora"
          name={KEYS.nombreInstitucionEmisora}
          {...commonProps(KEYS.nombreInstitucionEmisora)}
          sectionName={sectionName}
          isDisabled={isDisabled}
          isRequired={!isDisabled}
          maxLength={100}
        />
      </Div>
  );

  const diagnostico = (
    <div className="col-md-12">
      <InputTextArea
        label="Diagnóstico"
        direction="column"
        {...commonProps(KEYS.diagnostico)}
        isDisabled={isDisabled}
        isRequired={!isDisabled}
      />
    </div>
  );

  const comentario = (
    !isCreate && (
    <div className="col-md-12">
      <InputTextArea
        label="Comentario"
        direction="column"
        {...commonProps(KEYS.comentario)}
        isDisabled={isDisabled || (!isAdmin && formValues[KEYS.idEstadoAprobacion] === estados.Observado.id) }
        placeholder={(isDisabled || (!isAdmin && formValues[KEYS.idEstadoAprobacion] === estados.Observado.id)) && (isNullOrUndefinded(formValues[KEYS.comentario]) || formValues[KEYS.comentario] === "" )? "" : "Ingresar Comentario"}
      />
    </div>)
  );

  const declaracionJurada = isCreate && (
    <div className="col-sm-12 mt-2">
      <div className="form-check mb-0">
        <input
          type="checkbox"
          className="form-check-input"
          id="checkDeclaracionJuradaDM"
          checked={checkDeclaracionJurada ?? false}
          onChange={e => setCheckDeclaracionJurada(e.target.checked)}
          disabled={isDisabled}
        />
        <label
          className="form-check-label ficha-declaracion-jurada-message"
          htmlFor="checkDeclaracionJuradaDM"
        >
          <strong className="mb-0 text-justify">
            Declaro que la información y los documentos adjuntos son verídicos y auténticos, asumiendo la responsabilidad por cualquier falsedad, conforme a las políticas de la empresa.
          </strong>
        </label>
      </div>
    </div>
  );

  return (
    <>
      {alertRegistroPendiente}
      {alert20diasDMAlCrear()}
      {alert20diasDM}
      {alertaUmbralesComeciAlCrear()}
      {AlertaTieneDescansoMedicoAprobadoEnDiciembreDelAnioPasado()}
      {registradoEnOfisis}
      {derivadoPsicoEmocional}
      {descuentoEnPlanilla}
      {auditarDescansoMedico}
      {division}
      {intervaloDeDescansoMedico}
      {motivoDescansoMedico}
      {institucionDescansoMedico}
      {tieneSubsidio}

      {documentoCanjeDMEssaludCittFirmado}
      {cie10Campo}
      {puedeVerCamposAdmin && tipologiaCampo}
      {cmpCampo}
      {nombreMedicoCampo}
      {nombreInstitucionEmisora}
      {diagnostico}
      {comentario}
      {documentTable}
      {declaracionJurada}
    </>
  );
};

export default DescansoMedico
